import React from 'react';
import { useForm } from 'react-hook-form';
import { DevTool } from 'react-hook-form-devtools';
import { Paper, Box } from '@mui/material';
import Joi from '@hapi/joi';
import { TextFieldWrapper as TextField } from './Form/MuiFormWrapper';
import snackbarHelper from '../helpers/snackbarHelper';
import * as errorsHelper from '../helpers/errors';
import errorMessages from '../assets/errorMessages';
import ButtonWithLoading from './ButtonWithLoading';

const validationResolver = (data) => {
  const errors = {};
  const errorList = Joi.object()
    .keys({ name: Joi.string().required() })
    .messages({
      'string.empty': errorMessages.REQUIRED.message,
    })
    .validate(
      {
        name: data.name || '',
      },
      { abortEarly: false }
    );

  if (errorList.error) {
    errorList.error.details.forEach(error => {
      errors[error.context.key] = { message: error.message };
    });
  }

  return {
    values: Object.keys(errors).length ? {} : data,
    errors: errors,
  };
};

const UmbrellaFoodDonorEditForm = ({ umbrellaFoodDonor, onSubmit }) => {
  const {
    handleSubmit,
    register,
    getValues,
    errors,
    control,
    formState: { dirty, isSubmitting },
  } = useForm({
    validationResolver: validationResolver,
    defaultValues: {
      name: umbrellaFoodDonor.name,
    },
  });

  const submit = async values => {
    try {
      await onSubmit({
        id: umbrellaFoodDonor.id,
        name: values.name,
      });

      snackbarHelper.success('Umbrella Food Donor was updated successfully!');
    } catch (error) {
      errorsHelper.handleError(error);
    }
  };

  return (
    <Paper sx={{ padding: { xs: 1, sm: 2 } }}>
      <form style={{ maxWidth: 500 }} onSubmit={handleSubmit(submit)}>
        <DevTool control={control} />
        <Box display="grid" gridAutoFlow="row" rowGap={2}>
          <TextField
            required
            id="name"
            name="name"
            label="Umbrella Food Donor Name"
            variant="outlined"
            size="small"
            inputRef={register}
            InputLabelProps={{ shrink: !!getValues('name') || undefined }}
            error={!!errors.name}
            helperText={errors.name ? errors.name.message : ''}
          />

          <ButtonWithLoading type="submit" isLoading={isSubmitting} disabled={!dirty} data-testid="update-donor-button">
            Update Umbrella Food Donor
          </ButtonWithLoading>
        </Box>
      </form>
    </Paper>
  );
};

export default UmbrellaFoodDonorEditForm;
